
import { server2 } from "../constant/config";
import { useFetchData } from "../hooks/useFetchData";
import Spinner from "./Spinner";

const Information = ({ boardId, subjectId, chapterId, gradeId, topicId }) => {
  let { data: board, loading: boardLoading, error: boardError } =
    useFetchData(boardId ? `${server2}/v1/boards/${boardId}` : null);

  let { data: subject, loading: subjectLoading, error: subjectError } =
    useFetchData(subjectId ? `${server2}/v1/subjects/${subjectId}` : null);

  let { data: chapter, loading: chapterLoading, error: chapterError } =
    useFetchData(chapterId ? `${server2}/v1/chapters/${chapterId}` : null);
  
  let { data: grade, loading: gradeLoading, error: gradeError } =
    useFetchData(gradeId ? `${server2}/v1/classes/${gradeId}` : null);
  let { data: topic, loading: topicLoading, error: topicError } =
    useFetchData(topicId ? `${server2}/v1/topics/${topicId}` : null);
  if(!boardId){
    board={board:{name:"N/A"}};
    boardLoading=false;
    boardError=null;
  }
  if (!subjectId) {
    subject = { subjects: { name: "N/A" } };
    subjectLoading = false;
    subjectError = null;
  }
  if (!topicId) {
    topic = { topics: { name: "N/A" } };
    topicLoading = false;
    topicError = null;
  }
  if (!gradeId) {
    grade = { Classes: { name: "N/A" } };
    gradeLoading = false;
    gradeError = null;
  }
  if (!chapterId) {
    chapter = { chapters: { name: "N/A" } };
    chapterLoading = false;
    chapterError = null;
  }

  if (boardLoading || subjectLoading || chapterLoading || gradeLoading || topicLoading) {
    return <Spinner />;
  }

  if (boardError || subjectError || chapterError || gradeError || topicError) {
    return <div className="text-red-600 font-semibold text-center mt-4">Error loading information.</div>;
  }

  return (
    <div className="bg-white flex flex-row gap-4 shadow-sm rounded-xl p-4 mt-1 mx-auto w-5/6 border border-gray-200">

  {/* SECOND HEADER STYLE */}
 

      <div className="flex flex-wrap gap-x-4 gap-y-2 text-sm">
      <span className="text-base font-semibold text-gray-800 border-l-4 border-blue-500 pl-3 ">
    Information {"->"}
  </span>

    <div className="flex items-center gap-1">
      <span className="font-medium text-gray-700">Board:</span>
      <span className="text-gray-900">{board?.board?.name || "N/A"}</span>
    </div>

    <div className="flex items-center gap-1">
      <span className="font-medium text-gray-700">Subject:</span>
      <span className="text-gray-900">{subject?.subjects?.name || "N/A"}</span>
    </div>

    <div className="flex items-center gap-1">
      <span className="font-medium text-gray-700">Chapter:</span>
      <span className="text-gray-900">{chapter?.chapters?.name || "N/A"}</span>
    </div>

    <div className="flex items-center gap-1">
      <span className="font-medium text-gray-700">Grade:</span>
      <span className="text-gray-900">{grade?.Classes?.name || "N/A"}</span>
    </div>

    <div className="flex items-center gap-1">
      <span className="font-medium text-gray-700">Topic:</span>
      <span className="text-gray-900">{topic?.topics?.name || "N/A"}</span>
    </div>

  </div>
</div>
 );
};

export default Information;
